// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2NRVi","inner":"Footer_inner__4Zkif"};